<template>
  <div class="ConfInter">
    <div class="titlePage">Reporte {{this.$route.params.Report}}</div>
    <ValidationObserver ref="obsFieldsSearch">
      <FormSearchClient
        :FieldsForm="formSearch"
        :ModelForm="formSchModel"
        :method="loadReport"
        v-if="renderComponent1"
      />
    </ValidationObserver>
    <va-notification color="danger" v-if="refNoData" class="refNoData">No se encuentran informacion para el reporte.</va-notification>
    <DataList
    :InfoView="this.DLDataList"
    :HeadTable="this.HDDataList"
    :filterData="this.FilterData"
    v-if="renderComponent2"
    />
  </div>
</template>

<script>
import FormSearchClient from '@/components/forms/Forms.vue'
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataReportsOperator.vue'

export default {
  name: 'ReportInter',
  data () {
    return {
      formSchModel: {
        CodeOperator: '',
        NumIdentify: '',
        IdBannerNum: '',
      },
      formSearch: [
        {
          id: 'Sch_Operator',
          model: 'CodeOperator',
          name: 'Operador*',
          type: 'Select',
          class: 'col-md-3',
          values: [],
          validate: {
            required: true,
          },
        },
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Consultar',
          class: 'col-md-3',
        },
      ],
      FilterData: [
        {
          // ListPrograms: [],
          // ListFaculty: [],
        },
      ],
      HDDataList: [],
      DLDataList: [],
      refNoData: false,
      ReportModel: [],
      formUpdate: [],
      renderComponent1: false,
      renderComponent2: false,
    }
  },
  components: {
    FormSearchClient,
    DataList,
  },
  created: function () {
    if (this.$session.get('IberoJWTAdminLogin').idPerson !== undefined) {
      this.callLoadOperators()
    } else {
      this.$session.remove('IberoJWTAdminLogin')
      this.$router.push({ name: 'not-found-simple' })
    }
  },
  methods: {
    callLoadOperators () {
      this.renderComponent1 = false
      var linksData = IberoHelpers.getOperatorsByUser(
        this.$store,
        this.$session.get('IberoJWTAdminLogin').idPerson,
      )
      linksData.then(Response => {
        if (Response.data) {
          for (var i = 0; i < Response.data.length; i++) {
            var data = ''
            switch (decodeURIComponent(this.$route.params.Report)) {
              case 'Estado de Cartera':
                data = Response.data[i].Hom_Iceberg
                break
              default:
                data = Response.data[i].Hom_Banner
            }
            this.formSearch[0].values.push(
              { id: data, value: Response.data[i].Nam_Operator }
            )
          }
        }
        IberoHelpers.forceRerender1(this)
      })
    },
    loadReport (event, refer) {
      // this.limpiaref()
      this.refNoData = false
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.Reports(this.$route.params.Report, this.formSchModel)
          break
      }
    },
    Reports: function (report, parameters) {
      let loader = this.$loading.show()
      switch (decodeURIComponent(report)) {
        case 'Comisiones' :
          var DataCommissions = IberoHelpers.getCommissions(
            this.$store,
            this.formSchModel
          )
          this.renderComponent2 = false
          DataCommissions.then(Response => {
            this.LoadDataReport(Response.data, loader)
          })
          break
      }
    },
    LoadDataReport: function (data, loader) {
      if (data && data.length > 0) {
        var headers = Object.keys(data[0])
        for (var i = 0; i < headers.length; i++) {
          headers[i] = {
            name: headers[i],
            title: headers[i],
            dataClass: 'text-left',
          }
        }
        this.HDDataList = headers
        this.DLDataList = data
        // this.FilterData.ListPrograms = IberoHelpers.uniqueBy(
        //   data,
        //   'Nam_Program'
        // )
        // this.FilterData.ListFaculty = IberoHelpers.uniqueBy(
        //   data,
        //   'Nam_Faculty'
        // )
        IberoHelpers.forceRerender2(this)
      } else {
        this.refNoData = true
      }
      loader.hide()
    },
  },
}
</script>

<style>
.refNoData {
  padding: 10px;
  padding-left: 20px;
  margin-top: 30px;
  margin-bottom: 10px;
}
.listData{
  padding: 20px;
}

</style>
